import { environment } from '~/environments/environment';

export function isDebugToolsActive(): boolean {
  return (environment as any).debugTools;
}
